import { useState } from 'react';
import { testimonials } from '@/mocks/comics';

const avatarImages = [
  'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20male%20character%20portrait%2C%20young%20adult%20casual%20style%2C%20warm%20lighting%2C%20clean%20soft%20background%2C%20friendly%20expression%2C%20modern%20fashion%2C%20digital%20illustration%2C%20anime%20inspired%20artwork%2C%20simple%20composition&width=800&height=1000&seq=avatar-01&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20female%20student%20portrait%2C%20young%20woman%20in%20campus%20style%2C%20soft%20natural%20lighting%2C%20clean%20pastel%20background%2C%20cheerful%20smile%2C%20digital%20illustration%2C%20anime%20inspired%20artwork&width=800&height=1000&seq=avatar-02&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20office%20worker%20male%20portrait%2C%20business%20casual%20style%2C%20clean%20neutral%20background%2C%20calm%20confident%20expression%2C%20digital%20illustration%2C%20mature%20anime%20inspired%20artwork&width=800&height=1000&seq=avatar-03&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20female%20freelancer%20portrait%2C%20creative%20casual%20style%2C%20soft%20warm%20lighting%2C%20clean%20background%2C%20thoughtful%20expression%2C%20digital%20illustration%2C%20artistic%20anime%20inspired%20style&width=800&height=1000&seq=avatar-04&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20male%20designer%20portrait%2C%20stylish%20young%20man%2C%20creative%20casual%20outfit%2C%20clean%20studio%20background%2C%20friendly%20confident%20smile%2C%20digital%20illustration%2C%20anime%20inspired%20artwork&width=800&height=1000&seq=avatar-05&orientation=portrait',
];

export default function TestimonialSection() {
  const [current, setCurrent] = useState(0);

  const next = () => {
    setCurrent((prev) => (prev + 1) % testimonials.length);
  };

  const prev = () => {
    setCurrent((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const t = testimonials[current];

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-8 md:gap-12 items-center">
            <div className="w-full lg:w-2/5">
              <div className="relative rounded-2xl overflow-hidden aspect-[4/5] bg-background-200">
                <img
                  src={avatarImages[current]}
                  alt={t.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            <div className="w-full lg:w-3/5">
              <p className="text-primary-500 text-xs md:text-sm font-medium tracking-wider uppercase mb-3">
                用户口碑
              </p>
              <h3 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-2">
                听听读者们怎么说
              </h3>
              <p className="text-foreground-400 text-sm mb-8 md:mb-10">
                来自数百万读者的真实评价
              </p>

              <div className="relative">
                <div className="flex gap-1 mb-4">
                  {Array.from({ length: t.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-500 text-sm"></i>
                  ))}
                </div>
                <blockquote className="text-foreground-700 text-base md:text-lg leading-relaxed mb-6">
                  &ldquo;{t.content}&rdquo;
                </blockquote>
                <div className="flex items-center gap-1">
                  <span className="w-4 h-px bg-foreground-400"></span>
                  <span className="font-heading text-sm font-semibold text-foreground-900">{t.name}</span>
                  <span className="text-foreground-400 text-xs ml-2">{t.role}</span>
                </div>
              </div>

              <div className="flex items-center gap-3 mt-8">
                <button
                  onClick={prev}
                  className="w-9 h-9 rounded-full border border-foreground-300 flex items-center justify-center text-foreground-500 hover:text-foreground-900 hover:border-foreground-500 transition-colors cursor-pointer"
                  aria-label="上一条评价"
                >
                  <i className="ri-arrow-left-line"></i>
                </button>
                <button
                  onClick={next}
                  className="w-9 h-9 rounded-full bg-foreground-950 flex items-center justify-center text-white hover:bg-foreground-800 transition-colors cursor-pointer"
                  aria-label="下一条评价"
                >
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}